;(function () {
    "use strict";

    $(document).on("click.tag", ".tag_load-more", function(event) {
        event.preventDefault();

        var $hiddenTags = $(this).parent().find(".tag_hidden");
        $(this).addClass("tag_hidden");
        $hiddenTags.css("position", "relative");
        setTimeout(function() {$hiddenTags.removeClass("tag_hidden")}, 1); // hate it but can't really set a promise or cb
        $(document).trigger("tagShown");
    });

    $(document).on("click.tag", ".tag_dismissable", function() {

        var $tag = $(this),
            afterDismissCallback = $tag.data('afterDismissCallback');

        $tag.addClass('tag_hidden');

        if (typeof afterDismissCallback == 'function') {
            afterDismissCallback();
        }
    });
})();
